<template>
  <div class="grid" @dragover.prevent="handleDragOver" @drop="handleDrop" ref="gameBoard">
    <div class="row" v-for="(row, rowIndex) in board" :key="`grid-${rowIndex}`">
      <div class="cell" v-for="(block, blockIndex) in row" :key="`cell-${rowIndex}-${blockIndex}`"
           :class="{ 'filled-cell': block, 'hover-cell': isHoverCell(rowIndex, blockIndex), 'hover-x': isRemoveCell(rowIndex, blockIndex) }"
           :style="applyCellStyle(block)">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameGrid',
  props: {
    board: {
      type: Array,
      required: true
    },
    hoverCells: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleDragOver(event) {
      this.$emit('dragover', event);
    },
    handleDrop(event) {
      this.$emit('drop', event);
    },
    isHoverCell(row, col) {
      return this.hoverCells.some(cell => cell.row === row && cell.col === col);
    },
    isRemoveCell(row, col) {
      // Check if the cell is marked for removal
      // This assumes that hoverCells can contain both hover and remove states
      // the HoverCells array should have a property to distinguish between hover and remove
      return this.hoverCells.some(cell => cell.row === row && cell.col === col && cell.remove);
    },
    applyCellStyle(block) {
      if (block !== null) {
        return {
          background: `linear-gradient(145deg, ${block}, ${block} 50%, ${block} 50%, ${block} 100%)`,
        };
      }
      return {};
    }
  }
};
</script>
